import React from 'react';

const IconLoader = () => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    style={{ display: 'block', margin: '0 auto' }}>
    <title>Loader Logo</title>
    <g>
      {/* Daha düzgün elmas */}
      <polygon
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="50,10 90,50 50,90 10,50"
        fill="none"
      />
      {/* Ortalanmış E harfi */}
      <path
        d="M38,32 L62,32 L62,38 L44,38 L44,48 L60,48 L60,54 L44,54 L44,68 L62,68 L62,74 L38,74 Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default IconLoader;
